module.exports = __webpack_public_path__ + "static/img/process1.f8a23df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/process/process1.jpg
// module id = 1cXh
// module chunks = 0